import {CheckOutlined, CloseOutlined} from '@ant-design/icons';
import {TagProps} from 'antd/es/tag';
import {ProviderFieldsFragment} from 'api/generated';
import {StatusTag} from 'components/StatusTag';
import {colors} from 'lib/colors';
import React from 'react';

interface Props extends TagProps {
  provider: ProviderFieldsFragment;
}

export const ProviderStatusTags: React.FC<Props> = ({provider, ...props}) => {
  const getStatusTags = () => {
    const statusLabels = [];
    if (provider?.enabled) {
      statusLabels.push(
        <StatusTag {...props} color={colors.success} key="enabled">
          <CheckOutlined /> Enabled
        </StatusTag>
      );
    } else {
      statusLabels.push(
        <StatusTag {...props} color={colors.grey} key="disabled">
          <CloseOutlined /> Disabled
        </StatusTag>
      );
    }
    if (provider?.test) {
      statusLabels.push(
        <StatusTag {...props} color={colors.yellow} key="test">
          TEST
        </StatusTag>
      );
    }
    return statusLabels;
  };

  if (!provider) return <></>;

  return getStatusTags();
};
